import * as React from "react";
import type { SVGProps } from "react";
const SvgTandemTesting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M6.044 1.707a4.337 4.337 0 0 0-4.336 4.337v51.912a4.337 4.337 0 0 0 4.336 4.337h51.913a4.337 4.337 0 0 0 4.336-4.337V6.044a4.337 4.337 0 0 0-4.337-4.337H6.044ZM0 6.044A6.044 6.044 0 0 1 6.044 0h51.913A6.044 6.044 0 0 1 64 6.044v51.912A6.044 6.044 0 0 1 57.956 64H6.044A6.044 6.044 0 0 1 0 57.956V6.044Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M63.264 16.459H.97V14.75h62.293v1.708Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M8.503 10.258a1.834 1.834 0 1 0 0-3.668 1.834 1.834 0 0 0 0 3.668Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M8.503 7.444a.98.98 0 1 0 0 1.96.98.98 0 0 0 0-1.96Zm-2.688.98a2.688 2.688 0 1 1 5.376 0 2.688 2.688 0 0 1-5.376 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M17.127 10.258a1.834 1.834 0 1 0 0-3.668 1.834 1.834 0 0 0 0 3.668Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M17.127 7.444a.98.98 0 1 0 0 1.96.98.98 0 0 0 0-1.96Zm-2.687.98a2.688 2.688 0 1 1 5.375 0 2.688 2.688 0 0 1-5.376 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M25.751 10.258a1.834 1.834 0 1 0 0-3.668 1.834 1.834 0 0 0 0 3.668Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M25.751 7.444a.98.98 0 1 0 0 1.96.98.98 0 0 0 0-1.96Zm-2.688.98a2.688 2.688 0 1 1 5.376 0 2.688 2.688 0 0 1-5.375 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M55.527 24.58H29a1.07 1.07 0 0 0-1.073 1.069c0 .59.48 1.068 1.073 1.068h26.527a1.07 1.07 0 0 0 1.073-1.068c0-.59-.48-1.069-1.073-1.069ZM55.527 28.434H29a1.07 1.07 0 0 0-1.073 1.068c0 .59.48 1.069 1.073 1.069h26.527a1.07 1.07 0 0 0 1.073-1.069c0-.59-.48-1.068-1.073-1.068ZM46.718 32.278H29a1.07 1.07 0 0 0-1.073 1.068c0 .59.48 1.069 1.073 1.069h17.718a1.07 1.07 0 0 0 1.073-1.069c0-.59-.48-1.068-1.073-1.068ZM55.527 44.288H29a1.07 1.07 0 0 0-1.073 1.068c0 .59.48 1.068 1.073 1.068h26.527a1.07 1.07 0 0 0 1.073-1.068c0-.59-.48-1.068-1.073-1.068ZM55.527 48.132H29a1.07 1.07 0 0 0-1.073 1.068c0 .59.48 1.068 1.073 1.068h26.527A1.07 1.07 0 0 0 56.6 49.2c0-.59-.48-1.068-1.073-1.068ZM46.718 51.985H29a1.07 1.07 0 0 0-1.073 1.069c0 .59.48 1.068 1.073 1.068h17.718a1.07 1.07 0 0 0 1.073-1.068c0-.59-.48-1.069-1.073-1.069ZM20.757 23.215l-7.62 7.6-3.804-3.805-1.903 1.912 5.707 5.707 9.513-9.512-1.903-1.893.01-.01Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m21.458 22.728 1.793 1.784a.854.854 0 0 1 .002 1.209l-9.512 9.512a.854.854 0 0 1-1.207 0l-5.708-5.707a.854.854 0 0 1-.001-1.206l1.902-1.912a.854.854 0 0 1 1.209-.002l3.202 3.202 7.016-6.998a.854.854 0 0 1 1.304.118Zm-.71 1.701-7.008 6.99a.854.854 0 0 1-1.207 0l-3.2-3.2-.697.701 4.501 4.502 8.303-8.303-.692-.69Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M11.937 43.605 9.742 45.8l3.249 3.258-3.249 3.259 2.195 2.195 3.259-3.239 3.249 3.239 2.195-2.195-3.24-3.259 3.24-3.258-2.195-2.195-3.25 3.258-3.258-3.258Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M11.334 43.001a.854.854 0 0 1 1.207 0l2.654 2.654 2.645-2.653a.854.854 0 0 1 1.208 0l2.196 2.194a.854.854 0 0 1 .001 1.206l-2.64 2.656 2.64 2.657a.854.854 0 0 1-.002 1.206l-2.195 2.195a.854.854 0 0 1-1.206 0l-2.647-2.638-2.656 2.64a.854.854 0 0 1-1.205-.002L9.139 52.92a.854.854 0 0 1-.001-1.207l2.648-2.656-2.648-2.655a.854.854 0 0 1 0-1.207l2.196-2.195Zm-.385 2.8 2.647 2.655a.854.854 0 0 1 0 1.205l-2.647 2.655.99.99 2.655-2.638a.854.854 0 0 1 1.205 0l2.645 2.638.99-.99-2.639-2.656a.854.854 0 0 1 0-1.203l2.64-2.655-.99-.99-2.645 2.654a.853.853 0 0 1-1.208 0l-2.655-2.654-.988.989Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTandemTesting;
